import { useCurrentMember } from "@/hooks/use-current-member";
import { useOnboarding } from "@/hooks/use-onboarding";
import { OrganizationRole } from "gitpod-next-api/gitpod/v1/organization_pb";

export const useShowOnboarding = () => {
    const onboarding = useOnboarding();
    const { currentMember } = useCurrentMember();

    if (onboarding.steps.isLoading) {
        return false;
    }

    const isAdmin = currentMember?.role === OrganizationRole.ADMIN;
    const completed = onboarding.steps.steps.every((step) => step.completed);

    return isAdmin && !completed;
};
